module.exports = __webpack_public_path__ + "static/img/statistics-1.8becf991.png";